import { call, put, takeLatest, all } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import * as Constants from './constants'
import * as Actions from './actions'

const contestRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/contest/get-contest`;
const createRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/contest/create-contest`;
const updateRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/contest/update-contest`;
const ownerRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/getownerslist?owners=RECRUITER`;
const testRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/contest/recruiter-test`;
const locationRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/contest/get-location`;
const skillRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/contest/get-skills`;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then(response => response.json())
    .then(json => json)
    .catch((error) => { throw error })
}

function addRequestApi ({ data, pageMode }) {
  let url = '';

  switch(pageMode) {
    case 'edit':
      url = updateRequestUrl;
      break;
    case 'add':
      url = createRequestUrl;
      break;
    default:
    return ''
  }

  const request = fetch(url, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
  })

  return handleRequest(request)
}
function* addRequestFlow (action) {
  try {
    const result = yield call(addRequestApi, action)
    yield put(Actions.addSuccess(result))
  } catch (error) {
    yield put(Actions.addError(error))
  }
}

function getRequestApi ({ contestId }) {
  const request = fetch(contestRequestUrl, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ contest_id: contestId }),
  })

  return handleRequest(request)
}
function* getRequestFlow (action) {
  try {
    const result = yield call(getRequestApi, action)
    yield put(Actions.getSuccess(result))
  } catch (error) {
    yield put(Actions.getError(error))
  }
}

function ownerRequestApi ({ contestId }) {
  const request = fetch(ownerRequestUrl, {
    method: 'GET',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
  })

  return handleRequest(request)
}
function* ownerRequestFlow (action) {
  try {
    const result = yield call(ownerRequestApi, action)
    yield put(Actions.ownerSuccess(result))
  } catch (error) {
    yield put(Actions.ownerError(error))
  }
}

function testRequestApi ({ companyId }) {
  const request = fetch(testRequestUrl, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ company_id: companyId }),
  })

  return handleRequest(request)
}
function* testRequestFlow (action) {
  try {
    const result = yield call(testRequestApi, action)
    yield put(Actions.testSuccess(result))
  } catch (error) {
    yield put(Actions.testError(error))
  }
}

function locationRequestApi ({ location }) {
  const request = fetch(`${locationRequestUrl}?location=${location}`, {
    method: 'GET',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
  })

  return handleRequest(request)
}
function* locationRequestFlow (action) {
  try {
    const result = yield call(locationRequestApi, action)
    yield put(Actions.locationSuccess(result))
  } catch (error) {
    yield put(Actions.locationError(error))
  }
}

function skillRequestApi ({ skill }) {
  const request = fetch(`${skillRequestUrl}?skills=${skill}`, {
    method: 'GET',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
  })

  return handleRequest(request)
}
function* skillRequestFlow (action) {
  try {
    const result = yield call(skillRequestApi, action)
    yield put(Actions.skillSuccess(result))
  } catch (error) {
    yield put(Actions.skillError(error))
  }
}

function* contestWatcher () {
  yield all([
    takeLatest(Constants.ADD_REQUEST, addRequestFlow),
    takeLatest(Constants.GET_REQUEST, getRequestFlow),
    takeLatest(Constants.OWNER_REQUEST, ownerRequestFlow),
    takeLatest(Constants.TEST_REQUEST, testRequestFlow),
    takeLatest(Constants.LOCATION_REQUEST, locationRequestFlow),
    takeLatest(Constants.SKILL_REQUEST, skillRequestFlow),
  ])
}

export default contestWatcher
